<ng-container *ngIf="modal && form">
  <app-confirm-modal-template [form]="form" [modal]="modal">
    <div modalBody>
      <div>
          <form *ngIf="form" [formGroup]="form">
              <!-- First Name -->
              <div class="row">
                  <div
                          class="form-group col-sm-12"
                          appParentValidator
                          [control]="form.controls.firstname"
                  >
                      <div class="app-input">
                          <label for="firstname">{{ 'FNAME' | translate }}</label>
                          <input [readOnly]="isStudent" appAutocompleteOff type="text" formControlName="firstname" class="form-control" id="firstname" />
                      </div>
                      <app-form-error [control]="form.controls.firstname"></app-form-error>
                  </div>
              </div>

              <div class="row">
                  <!-- Last Name -->
                  <div
                          class="form-group col-sm-12"
                          appParentValidator
                          [control]="form.controls.lastName"
                  >
                      <div class="app-input">
                          <label for="lastname">{{ 'LNAME' | translate }}</label>
                          <input [readOnly]="isStudent" appAutocompleteOff type="text" formControlName="lastname" class="form-control" id="lastname" />
                      </div>
                      <app-form-error [control]="form.controls.lastname"></app-form-error>
                  </div>
              </div>

              <div class="row">
                  <!-- Default School -->
                  <div
                          class="form-group col-sm-12"
                          appParentValidator
                          [control]="form.controls.defaultSchool"
                  >
                      <app-school-select [form]="form" [controlName]="'defaultSchool'" [isProfileSettings]="true" label="{{ 'DEFAULT_SCHOOL' | translate }}"></app-school-select>

                      <app-form-error [control]="form.controls.defaultSchool"></app-form-error>
                  </div>
              </div>

              <div class="row">
                  <!-- Room -->
                  <div
                          *appHasAnyAuthority="[Authority.Admin, Authority.Staff, Authority.Teacher]"
                          class="form-group col-sm-12"
                          appParentValidator
                          [control]="form.controls.defaultRoom"
                  >
                      <app-auto-complete-room [form]="form"></app-auto-complete-room>

                      <app-form-error [control]="form.controls.defaultRoom"></app-form-error>
                  </div>
              </div>

              <div class="row">
                  <!-- Title -->
                  <div
                          *appHasAnyAuthority="[Authority.Admin, Authority.Staff, Authority.Teacher]"
                          class="form-group col-sm-12"
                          appParentValidator
                          [control]="form.controls.title"
                  >
                      <app-title-select [form]="form"></app-title-select>

                      <app-form-error [control]="form.controls.title"></app-form-error>
                  </div>
              </div>
          </form>
      </div>
    </div>

    <button confBtn type="button" class="btn btn-primary btn-padded btn-radius btn-block" (click)="onConfirm()">
      {{ modal.buttonText || ('CONFIRM' | translate) }}
    </button>
  </app-confirm-modal-template>
</ng-container>
